/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EpitetoAdminController', EpitetoAdminController);

    /* @ngInject */
    function EpitetoAdminController($timeout, $stateParams, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper,
                                    ModalService, Epiteto,  letras) {
        var vm = this;

        // Letras
        vm.letras = letras;


        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        vm.originalData = [];


        vm.item = Epiteto;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            key: undefined,
            letra: $stateParams.letra
        };

        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {nombre: 'asc'}
        }, NgTableHelper.settings(vm));


        // Eliminar
        vm.showRemoveConfirmation = function (id) {


            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    keyboard: false,
                    resolve: {
                        item: function () {
                            return Epiteto.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'admin.epiteto.delete.name',
                                body: 'admin.epiteto.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                var originalTable = vm.tableParams;
                for (i = 0; i < originalTable.data.length; i++) {
                    if (originalTable.data[i].id == id) {
                        originalTable.data.splice(i, 1);
                    }
                }

            });
        };


        //Añadir un elemento a la tabla
        vm.addElementTable = function () {

            var originalTable = vm.tableParams;

            //no se permite añadir varios simulatenamente
            if ((originalTable.data.length == 0) || (originalTable.data[0].id)) {

                var copia = {isEditing: true};
                originalTable.data.unshift(copia);
            }
        };


        //Edicion en linea: Guardar una copia de la fila que se va a editar
        vm.saveState = function (row, rowForm) {
            vm.originalData = angular.copy(row);
            var originalTable = vm.tableParams;

        };

        //Cancelar la edición de una fila
        vm.cancel = function (row, rowForm) {
            var originalTable = vm.tableParams;

            //Si se estaba añadiendo una nueva fila -> se elimina
            if (!row.id) {
                originalTable.data.shift();

            } else { //sino, se queda como estaba

                var originalRow = angular.copy(vm.originalData);
                angular.extend(row, originalRow);
                row.isEditing = false

            }
        };

        vm.save = function (row, rowForm) {

            new Epiteto(row).$save().then(function (data) {
                row.isEditing = false;
                rowForm.$setPristine();
                angular.extend(row, data);
            });

        };



    }


})(angular);


